var router = require('pjax').Router;
var theming = require('./theme.js');

router.get('theme', theming);
